import { render } from "./AchievementCard.vue?vue&type=template&id=1684d2fc&scoped=true"
import script from "./AchievementCard.vue?vue&type=script&lang=js"
export * from "./AchievementCard.vue?vue&type=script&lang=js"

import "./AchievementCard.vue?vue&type=style&index=0&id=1684d2fc&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1684d2fc"]])

export default __exports__